import { Constant } from "./layout.constant";

class LayoutData {
    static #CONT_PORT = "d$sd"
    static #CONT_LICENSE = "d$rt"
    static #CONT_SOURCE = "d$qw"

    static getPort() {
        const port = this.#getValue(this.#CONT_PORT)
        if (port) {
            return port
        } else {
            return 9523
        }
    }

    static savePort(value) {
        this.#saveValue(this.#CONT_PORT, value)
    }

    static getLicense() {
        return this.#getValue(this.#CONT_LICENSE)
    }

    static saveLicense(value) {
        this.#saveValue(this.#CONT_LICENSE, value)
    }

    static getSource() {
        return this.#getValue(this.#CONT_SOURCE)
    }

    static saveSource(value) {
        this.#saveValue(this.#CONT_SOURCE, value)
    }

    static #getValue(key) {
        const data = layui.data(Constant.DATA_LOCAL);
        return data[key]
    }

    static #saveValue(key, value) {
        layui.data(Constant.DATA_LOCAL, {
            key: key,
            value: value
        });
    }
}

export {
    LayoutData
}